module.exports = __webpack_public_path__ + "img/page-title-bg.53eb2a91.jpg";